import GATSBY_COMPILED_MDX from "/builds/fathomio/NuaLang/nualang.com/content/cookies/index.md";
import React from "react";
import PropTypes from "prop-types";
import {Helmet} from "react-helmet";
import {graphql} from "gatsby";
import Layout from "../layouts/Default";
import Section from "../components/Section";
import Content, {HTMLContent} from "../components/Content";
export const CookiesPageTemplate = ({content, contentComponent, isPreview, title, helmet}) => {
  const PostContent = contentComponent || Content;
  return React.createElement(Section, {
    sx: theme => ({
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6)
    }),
    className: "content"
  }, helmet || "", React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "columns"
  }, React.createElement("div", {
    className: "column is-10 is-offset-1"
  }, React.createElement("div", {
    className: "section"
  }, React.createElement("h2", {
    className: "title is-size-3 has-text-weight-bold is-bold-light"
  }, title), isPreview ? React.createElement(PostContent, {
    content: content
  }) : content)))));
};
CookiesPageTemplate.propTypes = {
  isPreview: PropTypes.bool,
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  title: PropTypes.string,
  helmet: PropTypes.object
};
const CookiesPage = ({data, children}) => {
  const {mdx: post, site: {siteMetadata: {title}}} = data;
  const {frontmatter} = post;
  return React.createElement(Layout, null, React.createElement(CookiesPageTemplate, Object.assign({
    helmet: React.createElement(Helmet, {
      title: `Cookies | ${title}`
    }),
    content: children,
    contentComponent: HTMLContent
  }, frontmatter)));
};
CookiesPage.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object,
  children: PropTypes.node
};
CookiesPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(CookiesPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query CookiesPageTemplate {
    site {
      siteMetadata {
        title
      }
    }
    mdx(frontmatter: { templateKey: { eq: "cookies-page" } }) {
      frontmatter {
        title
      }
    }
  }
`;
